<template>
  <div id="app">
    <addBlockChecker :show="showBlockNotify"></addBlockChecker>
    <transition name="fade" mode="out-in">
      <router-view v-if="getCompanyId" />
      <router-view name="error" />
    </transition>
  </div>
</template>

<script>
  import addBlockChecker from "./components/common/addBlockerChecker";
  import SetSidMixin from '@/setCidMixin'

  export default {
    mixins: [SetSidMixin],
    data() {
      return {
        showBlockNotify: false
      }
    },
    components: {addBlockChecker}
  }
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.modal_info + .client-main-body .client-map {
  height: calc(100vh - 482px);
  min-height: 200px;
}

</style>
